module.exports = __webpack_public_path__ + "media/images/pro_subscription/partnership/v2/partenariat4@2x-296bf4abdb1be81c443fd8fd31be522b.jpg";